import { render } from "./StartModal.vue?vue&type=template&id=3c1e8340&scoped=true"
import script from "./StartModal.vue?vue&type=script&lang=js"
export * from "./StartModal.vue?vue&type=script&lang=js"

import "./StartModal.vue?vue&type=style&index=0&id=3c1e8340&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1e8340"]])

export default __exports__